import {
  Context,
  descending,
  entity,
  like,
  likeAny,
  notNull,
  query,
  some,
  string,
  truthy,
} from '~/prix'
import unaccent from '~/prix/functions/unaccent'

export default function AttendantListQuery(input: string, context: Context) {
  return query('legalEntityAttendanceAttendant')
    .join({
      current: entity('legalEntityAttendanceAttendant').property('cpf'),
      target: entity('attendant').property('cpf'),
      join: 'inner',
    })
    .select({
      hash: entity('legalEntityAttendanceAttendant').property('hash'),
      agentCpf: entity('legalEntityAttendanceAttendant').property('cpf'),
      name: entity('legalEntityAttendanceAttendant').property('coalesce'),
      order: entity('legalEntityAttendanceAttendant').property('endDate'),
      stateAbbreviation: entity('legalEntityAttendanceAttendant').property('stateAbbreviation'),
    })
    .where(
      ...[
        some(notNull(entity('attendant').property('serviceArea'))),
        some(
          like(
            unaccent(entity('legalEntityAttendanceAttendant').property('name')),
            unaccent(
              string().value(
                `%${
                  context.user?.roles.includes('agent')
                    ? context.user.name
                    : input.replace(/\s/g, '%')
                }%`,
              ),
            ),
          ),
          like(
            entity('legalEntityAttendanceAttendant').property('cpf'),
            string().value(
              `%${
                context.user?.roles.includes('agent') ? context.user.cpf : input.replace(/\s/g, '%')
              }%`,
            ),
          ),
        ),
        context.user?.roles.includes('stateManager') && context.user.stateAbbreviation
          ? likeAny(string().value(context.user.stateAbbreviation), [
              entity('legalEntityAttendanceAttendant').property('stateAbbreviation') as any,
            ])
          : null,
      ].filter(truthy),
    )
    .order(descending('order'))
    .limit(20)
}
